import * as React from 'react';
import {Container, Image} from './styles';
import logo from '../../../assets/logos/logoTopii.svg';

interface Props {
  src?: string;
  width?: number;
  height?: number;
  className?: any;
}

const Logo: React.FC<Props> = ({
  src = logo,
  width = 95,
  height = 75,
  className,
}) => {
  return (
    <Container className={className}>
      <Image src={src} width={width} height={height}  />
    </Container>
  );
};

export default Logo;
